import React, { Component } from 'react';
import ScreenContainer from '../../ui/ScreenContainer';
import EditGrid from '../../ui/EditGrid/EditGrid';
import * as apiDashBoardService from './apiRequestService';
import * as Actions from '../../../redux/actions';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import {styleForHeader} from '../../../style.js';

class CompanyFtp extends Component {
    constructor(props) {
      super(props);
      this.state = {
        gridFunc:null,
        gridColumns : [
            { field: 'id', hide: true},
            { field: 'code', width: 100, headerAlign:'left', align:'left', text:'Ftp Adı',renderHeader: () => styleForHeader('Ftp Adı')},
            { field: 'ftpAddress', width: 400, headerAlign:'left', align:'left', text:'Ftp Adres',renderHeader: () => styleForHeader('Ftp Adres')},
            { field: 'port', width: 100, headerAlign:'left', align:'left', type: 'number', text:'Port',renderHeader: () => styleForHeader('Port')},
            { field: 'userName', width: 200, headerAlign:'left', align:'left', text:'Kullanıcı Adı',renderHeader: () => styleForHeader('Kullanıcı Adı')},
            { field: 'password', width: 100, headerAlign:'left', align:'left', type: 'password', text:'Şifre',renderHeader: () => styleForHeader('Şifre')}
        ],
        CRUDServices:{
          Create:apiDashBoardService.createFtpAddress,
          Update:apiDashBoardService.updateFtpAddress,
          Delete:apiDashBoardService.deleteFtpAddress}
      };
    }
    refreshList(){
      apiDashBoardService.getAllFtpAddress()
      .then((response) => {
        this.gridFunc.state.gridRows= response.data;
        this.gridFunc.state.gridColumns= this.state.gridColumns;
        this.gridFunc.state.columnVisibilityModel= {id:false,port:false,userName:false,password:false};
    
        this.gridFunc.setState(this.gridFunc.state)
      })
      .catch((exception) => {
        this.props.actions.setNotification("Firma ftp bilgileri getirilemedi daha sonra tekrar deneyin.", 'error');
        console.log('getAllFtpAddress exception: ' + JSON.stringify(exception));
      });      
    }
    componentDidMount() {
      this.refreshList();
    }
  
    closeEditPage(ele) {
      this.refreshList();
    }
    
    render() {
      const { CRUDServices } = this.state;

      return (
        <div>
          <div style = {{display: 'flex',
            flexDirection: 'column'}}>
            <ScreenContainer>
              <EditGrid ref={instance => { this.gridFunc = instance; }} dialogTitle="Firma Ftp Adres Tanımı" gridHeight={400} {...this.props} CRUD={CRUDServices} 
              LoadData={(e) => this.closeEditPage(e)}/>
            </ScreenContainer>     
          </div>
        </div>
      );
    }
  }

  const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
  });

  export default compose(
    connect(
      null,
      mapDispatchToProps
    )
  )(CompanyFtp);